import React from 'react';
import styled from 'styled-components';
import { ButtonConnect } from '../components/Header/ButtonConnect';

const FullPage = styled.div`
  height: 100vh;
`;

const Container = styled.div`
  display: flex;
  margin: auto;
  border: 1px solid rgba(251, 251, 255, 0.15);
  border-radius: var(--card-radius);
  height: 13rem;
  width: 38rem;
  padding: 1rem;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const Text = styled.p`
  color: var(--text-primary-white);
  font-size: var(--h2-font-size);
  font-family: Helvetica Neue 700;
  font-weight: 700;
  margin-bottom: 1rem;
  text-align: center;

  @media only screen and (max-width: 499px) {
    width: 85%;
  }
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
`;

interface Props {
  onClick: () => void;
}

export const ConnectEmptyState: React.FC<Props> = ({ onClick }) => {
  return (
    <FullPage>
      <Container>
        <SubContainer>
          <Text>Connect your wallet to view your portfolio</Text>
          <ButtonConnect location="page" onClick={onClick} />
        </SubContainer>
      </Container>
    </FullPage>
  );
};
